import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

export interface BrandKitColors {
  primary?: string;
  secondary?: string;
  accent?: string;
  background?: string;
  text?: string;
}
export interface BrandKitFonts {
  heading?: string;
  body?: string;
}
export interface BrandLogoSlot {
  id: string;
  url: string;
  mimeType: string;
  width: number | null;
  height: number | null;
}
export interface BrandFontFile {
  id: string;
  url: string;
  fontWeight: number | null;
  fontStyle: "normal" | "italic" | null;
}
export interface BrandFontFamilySlot {
  id: string;
  name: string;
  source: "GOOGLE" | "CUSTOM";
  files: BrandFontFile[];
}
export interface BrandKit {
  colors: BrandKitColors;
  fonts: BrandKitFonts;
  logoUrl: string | null;
  voiceProfile: string | null;
  primaryLogoAssetId: string | null;
  headingFontFamilyId: string | null;
  bodyFontFamilyId: string | null;
  primaryLogo: BrandLogoSlot | null;
  headingFontFamily: BrandFontFamilySlot | null;
  bodyFontFamily: BrandFontFamilySlot | null;
  contentLanguage?: string;
  languageVariant?: string | null;
}

export function useKit(brandId: string) {
  return useQuery({
    queryKey: ["kit", brandId],
    queryFn: () => apiFetch<BrandKit>(`/brands/${brandId}/kit`),
    enabled: !!brandId,
  });
}

export function useUpdateKit(brandId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<BrandKit>) =>
      apiFetch<BrandKit>(`/brands/${brandId}/kit`, {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["kit", brandId] }),
  });
}
